// CSS UI tabsの[data-tab]:checkedのvalueと、[data-tab-panel]のvalueを紐付ける
export const tabs = (): void => {
  (function(window, document) {
    const tabs = document.querySelectorAll<HTMLInputElement>("input[data-tab]");
    const panels = document.querySelectorAll<HTMLElement>("[data-tab-panel]");

    if (!tabs || !panels) return;

    /**
     * タブがアクティブ常態かチェックする
     * @param targetTabElem
     */
    const tabIsActive = (targetTabElem: HTMLInputElement): boolean => {
      if (targetTabElem.checked) {
        return true;
      }

      return false;
    };
    /**
     * タブパネルを全て停止状態にする
     * @param panels
     */
    const restTabPanelsStatus = (panels): void => {
      panels.forEach(e => {
        e.dataset.tabPanelActive = "false";
      });
    };
    /**
     * DOMContentLoaded時の処理
     */
    const initPanelStatus = (targetTabElem: HTMLInputElement, targetPanelElm: HTMLElement) => {
      // 初期状態は必ず1つ目がactive
      // if (0 === index) {
      //     targetTabElem.checked = true;
      //     targetPanelElm.dataset.tabPanelActive = 'true';
      //     return;
      // }
      //
      // targetTabElem.checked = false;
      // targetPanelElm.dataset.tabPanelActive = 'false';
      if (tabIsActive(targetTabElem)) {
        targetPanelElm.dataset.tabPanelActive = "true";
      } else {
        targetPanelElm.dataset.tabPanelActive = "false";
      }

      return;
    };
    const togglePanelStatus = (panels, targetTabElem: HTMLInputElement, targetPanelElm: HTMLElement) => {
      restTabPanelsStatus(panels);

      if (tabIsActive(targetTabElem)) {
        targetPanelElm.dataset.tabPanelActive = "true";
      } else {
        targetPanelElm.dataset.tabPanelActive = "false";
      }
    };
    const getOwnTabPanel = (tabElem) => {
      const tabName: string | null = tabElem.getAttribute("data-tab");
      if (!tabName) return null;

      return document.querySelector<HTMLInputElement>("[data-tab-panel=\"" + tabName + "\"]");
    };

    // input[data-tab]と[data-tab-panel]を紐付け、連動させる
    tabs.forEach((tabElem) => {
      // Init
      const ownTabPanelElem = getOwnTabPanel(tabElem);
      if (!ownTabPanelElem) return;
      initPanelStatus(tabElem, ownTabPanelElem);

      // inputを監視しパネルを連動させる
      tabElem.addEventListener("change", () => {
        togglePanelStatus(panels, tabElem, ownTabPanelElem);
      }, { passive: false });
    });

    window.addEventListener("pageshow", () => {
      tabs.forEach((tabElem) => {
        // Init
        const ownTabPanelElem = getOwnTabPanel(tabElem);
        if (!ownTabPanelElem) return;
        initPanelStatus(tabElem, ownTabPanelElem);
      });
    }, { passive: false });
  })(window, document);
};